import { ILogger } from './interface';
import type { Level, Logger as TLogger, RootLogger } from './types';

class Logger<T extends RootLogger> implements ILogger {
  private logger: TLogger;

  constructor(_logger: T, scope: string) {
    this.logger = _logger.getLogger(scope);
    this.logger.setDefaultLevel('WARN');
  }

  setLevel(level: Level): void {
    this.logger.setLevel(level);
  }

  log(...msg: unknown[]): void {
    this.logger.log('[LOG]', ...msg);
  }

  warn(...msg: unknown[]): void {
    this.logger.warn('[WARN]', ...msg);
  }

  error(...msg: unknown[]): void {
    this.logger.error('[ERROR]', ...msg);
  }

  debug(...msg: unknown[]): void {
    this.logger.debug('[DEBUG]', ...msg);
  }

  info(...msg: unknown[]): void {
    this.logger.info('[INFO]', ...msg);
  }

  trace(...msg: unknown[]): void {
    this.logger.trace('[TRACE]', ...msg);
  }
}

export default Logger;
